// Minimal transient notifications — used by the logic engine's `notify` action and
// available app-wide. Auto-dismiss; newest at the bottom.
import { writable } from 'svelte/store';

export interface Toast { id: number; message: string; }
export const toasts = writable<Toast[]>([]);

let seq = 0;
export function pushToast(message: string, ms = 4500): void {
  const id = ++seq;
  toasts.update((t) => [...t, { id, message: String(message || '') }]);
  setTimeout(() => toasts.update((t) => t.filter((x) => x.id !== id)), ms);
}
